import { buildPointKey } from '../area'
import { splitArray } from '@terros/common'
import type Supercluster from 'supercluster'

export const getLocationGroups = <U extends any, T extends Supercluster.PointFeature<U>>(
  locations: T[]
): { singles: T[]; groups: Map<string, T[]> } => {
  const map = new Map<string, T[]>()

  locations.forEach((location) => {
    const key = buildPointKey(location.geometry)
    if (!map.has(key)) {
      map.set(key, [])
    }
    map.get(key)?.push(location)
  })

  const locationGroups = Array.from(map.entries())
  const { yes: groups, no: singles } = splitArray(locationGroups, ([_, points]) => points.length > 1)

  return {
    singles: singles.flatMap(([_, points]) => points),
    groups: new Map(groups),
  }
}
